// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/lead-monitor/page"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/lead-monitor/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "Lead Monitor" })
  return <Page />
}
